import React from 'react';

type ViewMode = 'grid' | 'list';

interface ViewToggleProps {
  viewMode: ViewMode;
  onViewChange: (mode: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ viewMode, onViewChange }) => {
  const baseClasses = "p-2 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-purple focus:ring-opacity-50";
  const activeClasses = "bg-brand-purple text-white";
  const inactiveClasses = "bg-gray-200 text-gray-500 hover:bg-gray-300";

  return (
    <div className="flex items-center space-x-2 bg-gray-200 p-1 rounded-lg">
      <button
        onClick={() => onViewChange('list')}
        className={`${baseClasses} ${viewMode === 'list' ? activeClasses : inactiveClasses}`}
        aria-label="List View"
        aria-pressed={viewMode === 'list'}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <button
        onClick={() => onViewChange('grid')}
        className={`${baseClasses} ${viewMode === 'grid' ? activeClasses : inactiveClasses}`}
        aria-label="Grid View"
        aria-pressed={viewMode === 'grid'}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
      </button>
    </div>
  );
};

export default ViewToggle;